// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"c993f13e","151":"347389c5","364":"a7b9ae75","592":"f0c2f0f6","642":"e6d2f6e9","663":"cd70780e","836":"f8b6b890"}[chunkId] + ".chunk.js";
};